
class HXFormFieldTextAreaHistory extends HXFormField {

    static MAXLENGTH_UNLIMITED = 0; // Konstante fuer unbegrenzten Inhalt

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = ''+this.getValue();

            if (!this.getOptional() && value === '') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;

            } else if (value!=='' && value.length>hx.cint(this.getMaxLength()) && this.getMaxLength()!==HXFormFieldTextAreaHistory.MAXLENGTH_UNLIMITED) {
                this.validationMsg = hx.replace(this.formVars.dictLengthMsg, "#name#", this.getLabel());
                this.validationMsg = hx.replace(this.validationMsg, "#maxlength#", hx.cint(this.getMaxLength()));
                this.validationMsg = hx.replace(this.validationMsg, "#length#", value.length);
                this.inputObj.setSelectionRange(this.getMaxLength(), value.length); //Zu langen Text markieren
                this.validationPassed = false;
            }

            if (alertResult===true) super._validateFieldAlert();

        }
        return this.validationPassed;
    }

    /**
     * @returns {int}
     */
    getMaxLength() {
        return hx.cint(this.inputObj.getAttribute('data-hx-maxlength'));
    }

    /**
     * Maximal erlaubte Zeichen im Eingabefeld
     * @param {int} maxLength, 0.. unbegrenzt
     */
    setMaxLength(maxLength) {
        this.inputObj.setAttribute('data-hx-maxlength', maxLength);
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'textarea');
    }

    /**
     */
    displayInit() {
    }

}